<div class="modal fade" id="paymentOptionsModal" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <form #billingAddressForm="ngForm" novalidate (ngSubmit)="getTokenAndInitiatePayment(billingAddressForm)">
    <div class="modal-content">
      <div class="modal-header popup-header">
        <!-- <i *ngIf="accountPaymentSetting && accountPaymentSetting.paymentInstruments && accountPaymentSetting.paymentInstruments.length > 0" 
          class="fas fa-arrow-left mr-2 maroon pointer align-self-center" (click)="onBackClick()" aria-hidden="true"></i> -->
        <h5 class="modal-title" id="apiAccessTitle">Select Payment Method for {{invoice.invoiceSummary.total | number : '1.2-2'}} {{invoice.invoiceSummary.currency}}</h5>
        <button id="closePaymentModal" type="button" class="close" data-dismiss="modal" (click)="resetFormData(); cardConnect.resetIframe();" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row mt-1">
          <div class="col-12">
            <label><span class="maroon astrisk mt-2">&#10033;&nbsp;</span>Payment Option</label>
            <div class="row">
              <div class="col">
                <div *ngFor="let paymentType of paymentTypes;" class="custom-control custom-radio custom-control-inline">
                  <input type="radio" id="{{paymentType}}_Radio" name="{{paymentType}}_Radio" value="{{paymentType}}"
                    [(ngModel)]="paymentModel.paymentType" [ngModelOptions]="{standalone: true}" class="custom-control-input" (ngModelChange)="onChangePaymentType($event)">
                  <label class="custom-control-label" for="{{paymentType}}_Radio">{{paymentType}}</label>
                </div>
              </div>
            </div>
          </div>
          <ng-container *ngIf="paymentModel.paymentType == paymentTypes[0]">
            <div class="col-12 mt-2">
              <label><span class="maroon astrisk mt-2">&#10033;&nbsp;</span>Account Detail (Routing#/Account#)</label>
            </div>
            <div class="col-12">
              <card-connect [paymentType]="paymentModel.paymentType" #cardConnect></card-connect>
            </div>
            <div class="col-12">
              <span class="text-muted txt-small">Please input the Routing Number and Account Number in the format Routing#/Account#.</span>
              <br><label class="mt-1">
                <span class="text-muted font13-400">For example :</span><br>123456789/1234123412341234</label><br>
            </div>
            <div class="col-12 mt-2">
              <label><span class="maroon astrisk mt-2">&#10033;&nbsp;</span>Account Type</label>
              <div>
                <select id="loc" class="w-64" [(ngModel)]="selectedAccountType" [ngModelOptions]="{standalone: true}" name="selectionOption"
                  #selectionOption="ngModel" disabled>
                  <option *ngFor="let accountType of accountTypes;" [ngValue]="accountType">
                    {{accountType | customText}}
                  </option>
                </select>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="paymentModel.paymentType == paymentTypes[1]">
            <div class="col-12 mt-2">
              <card-connect [paymentType]="paymentModel.paymentType" #cardConnect></card-connect>
            </div>
          </ng-container>
            <div class="col-12 mt-2">
          
              <div class="row mt-2 mb-1">
                <div class="col-12 mt-2">
                  <label><span class="maroon astrisk mt-2">&#10033;&nbsp;</span>
                    <span *ngIf="paymentModel.paymentType == paymentTypes[0]">Account</span>
                    <span *ngIf="paymentModel.paymentType == paymentTypes[1]">Card</span>&nbsp;Holder Name</label>
                  <input type="text" class="form-control" [(ngModel)]="billingAddressModel.accountHolderName" name="accountHolderName"
                    #accountHolderName="ngModel" required>
                  <small class="text-danger text-center" *ngIf="accountHolderName.errors && billingAddressForm.submitted">
                    <p class="mb-0" *ngIf="accountHolderName.errors.required">*Required</p>
                  </small>
                </div>
                <div class="col-12 mt-2">
                  <label class="font14-600">Billing Address</label>
                </div>
                <div class="col-12 mt-2">
                  <div *ngFor="let addressType of addressTypes;" class="custom-control custom-radio custom-control-inline">
                    <input type="radio" id="{{addressType}}_Radio" name="{{addressType}}_Radio" value="{{addressType}}"
                      [(ngModel)]="billingAddressModel.addressType" class="custom-control-input">
                    <label class="custom-control-label" for="{{addressType}}_Radio">{{addressType}}</label>
                  </div>
                </div>
              </div>
          
              <div class="mt-1" *ngIf="billingAddressModel.addressType == addressTypes[2]">
          
                <div class="form-group mb-1">
                  <label><span class="maroon astrisk">&#10033;&nbsp;</span>Street Address</label>
                  <input type="text" class="form-control" [(ngModel)]="billingAddressModel.address.street" name="street"
                    #street="ngModel" required>
                  <small class="text-danger text-center" *ngIf="street.errors && billingAddressForm.submitted">
                    <p class="mb-0" *ngIf="street.errors.required">*Required</p>
                  </small>
                </div>
                <div class="row">
                  <div class="col mt-1">
                    <div class="form-group mb-1">
                      <label><span class="maroon astrisk">&#10033;&nbsp;</span>Zip Code</label>
                      <input type="text" class="form-control" [(ngModel)]="billingAddressModel.address.zipCode" name="zip"
                        #zip="ngModel" pattern="[0-9]{5}" (input)="getZipCodeDetails($event.target.value)" maxlength="5"
                        oninput="this.value = this.value.replace(/[^0-9]/g, '');" required>
                      <small class="text-danger text-center" *ngIf="zip.errors && billingAddressForm.submitted">
                        <p class="mb-0" *ngIf="zip.errors.required">*Required</p>
                        <p class="mb-0" *ngIf="!zip.errors.required && !invalidZipCode">Invalid Zip Code</p>
                      </small>
                      <small class="text-danger text-center" *ngIf="invalidZipCode">
                        <p class="mb-0">Invalid Zip Code</p>
                      </small>
                    </div>
                  </div>
                  <div class="col pl-0 mt-1">
                    <div class="form-group mb-1">
                      <label>Plus4 Code</label>
                      <input type="text" class="form-control" [(ngModel)]="billingAddressModel.address.plus4Code" name="plus4Code"
                        #plus4Code="ngModel" pattern="[0-9]{4}" maxlength="4" minlength="4"
                        oninput="this.value = this.value.replace(/[^0-9]/g, '');">
                      <small class="text-danger text-center" *ngIf="plus4Code.errors && billingAddressForm.submitted">
                        <p class="mb-0" *ngIf="plus4Code.errors?.pattern">Invalid Plus4 Code</p>
                      </small>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col mt-1">
                    <div class="form-group mb-1">
                      <label><span class="maroon astrisk">&#10033;&nbsp;</span>City</label>
                      <input type="text" class="form-control" [(ngModel)]="billingAddressModel.address.city" name="city"
                        #city="ngModel" required>
                      <small class="text-danger text-center" *ngIf="city.errors && billingAddressForm.submitted">
                        <p class="mb-0" *ngIf="city.errors.required">*Required</p>
                      </small>
                    </div>
                  </div>
                  <div class="col pl-0 mt-1">
                    <div class="form-group mb-1">
                      <label><span class="maroon astrisk">&#10033;&nbsp;</span>State</label>
                      <select id="model" class="w-100" aria-placeholder="Select State"
                        [(ngModel)]="billingAddressModel.address.state" name="state" #state="ngModel" required>
                        <option [ngValue]="null">Select State</option>
                        <option *ngFor="let state of stateList" value={{state}}>{{state}}</option>
                      </select>
                      <small class="text-danger text-center" *ngIf="state.errors && billingAddressForm.submitted">
                        <p class="mb-0" *ngIf="state.errors.required">*Required</p>
                      </small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          <div *ngIf="errorMessage" class="col-12 mt-2">
            <small class="text-danger text-center">
              <p class="mb-0">*{{errorMessage}}</p>
            </small>
          </div>
        </div>
        <!-- <div class="row mt-2">
          <div class="col-12">
            <div class="custom-control custom-checkbox">
              <input type="checkbox" class="custom-control-input" id="saveAccountDetail" [(ngModel)]="paymentModel.saveAccountDetail">
              <label class="custom-control-label" for="saveAccountDetail">Do you want to save the details for future
                payments?</label>
            </div>
          </div>
          <div class="col-12">
            <div class="custom-control custom-checkbox">
              <input type="checkbox" class="custom-control-input" id="autoPay" [(ngModel)]="paymentModel.autoPay">
              <label class="custom-control-label" for="autoPay">Auto Pay</label>
            </div>
          </div>
        </div> -->
      </div>
      <div class="modal-footer pt-1 pb-1">
        <div class="row mr-auto" style="min-height: 12vh;">
          <div class="col-12 align-self-start">
            <div class="custom-control custom-checkbox">
              <input type="checkbox" class="custom-control-input" id="saveAccountDetail"
                [(ngModel)]="paymentModel.savePaymentInstrument" [ngModelOptions]="{standalone: true}">
              <label class="custom-control-label" for="saveAccountDetail">Save payment instrument for future payments</label>
            </div>
          </div>
          <div *ngIf="paymentModel.savePaymentInstrument && accountPaymentSetting && accountPaymentSetting.paymentInstruments.length > 0" class="col-12">
            <div class="custom-control custom-checkbox">
              <input type="checkbox" class="custom-control-input" id="defaultPaymentMode"
                [(ngModel)]="paymentModel.defaultPaymentMode" [ngModelOptions]="{standalone: true}">
              <label class="custom-control-label" for="defaultPaymentMode">Set as default</label>
            </div>
          </div>
          <div class="col-12 align-self-end">
            <i *ngIf="accountPaymentSetting && accountPaymentSetting.paymentInstruments && accountPaymentSetting.paymentInstruments.length > 0" 
              class="fas fa-arrow-left mr-2 maroon pointer align-self-center" (click)="onBackClick()" aria-hidden="true"></i>
          </div>
          <!-- <div class="col-12">
            <div class="custom-control custom-checkbox">
              <input type="checkbox" class="custom-control-input" id="autoPay" [(ngModel)]="paymentModel.autoPay">
              <label class="custom-control-label" for="autoPay">Auto Pay</label>
            </div>
          </div> -->
        </div>
        <!-- <button type="button" class="btn btn-light" data-dismiss="modal">CANCEL</button> -->
        <button type="submit" class="btn btn-primary btn-80">PAY</button>
      </div>
    </div>  
    </form>
  </div>
</div>

<button type="button" class="btn btn-primary" id="openPaymentOptionsModal" [hidden]="true" data-toggle="modal"
  data-target="#paymentOptionsModal" data-backdrop="static" data-keyboard="false">Hidden Btn</button>